
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1qkal_1dwqa_11",
  "avatar-color-default": "awsui_avatar-color-default_1qkal_1dwqa_46",
  "avatar-color-gen-ai": "awsui_avatar-color-gen-ai_1qkal_1dwqa_49",
  "initials": "awsui_initials_1qkal_1dwqa_52",
  "content": "awsui_content_1qkal_1dwqa_80"
};
  